export default __webpack_public_path__ + "static/media/icons8-flag-filled.062f8358.svg";